import { useEffect } from "react";

export const useInjectHeadScripts = () => {
  const analyticsEnabled = window.AppENV.analyticsEnabled;
  useEffect(() => {
    if(!analyticsEnabled){
      return;
    }
    // Google Tag Manager
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WT7WBGF');`;
    document.head.appendChild(gtmScript);

    // Meta Pixel Code
    const fbPixelScript = document.createElement("script");
    fbPixelScript.innerHTML = `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '592232429092515');
      fbq('track', 'PageView');`;
    document.head.appendChild(fbPixelScript);

    const noScript = document.createElement("noscript");
    noScript.innerHTML = `<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=592232429092515&ev=PageView&noscript=1"
      />`;
    document.head.appendChild(noScript);

    // Cleanup function
    return () => {
      document.head.removeChild(gtmScript);
      document.head.removeChild(fbPixelScript);
      document.head.removeChild(noScript);
    };
  }, [analyticsEnabled]);
};

export const useInjectBodyScripts = (hasMetaScripts = false) => {
  const analyticsEnabled = window.AppENV.analyticsEnabled;
  useEffect(() => {
    if(!analyticsEnabled){
      return;
    }
    const scripts = [];
    const noscripts = [];

    const scriptConfigs = [
      {
        src: "https://www.googletagmanager.com/gtag/js?id=G-761KPHD265",
        async: true,
      },
      {
        innerHTML: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-761KPHD265');
          `,
      },
      hasMetaScripts
        ? {
            innerHTML: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '592232429092515');
            fbq('track', 'PageView');
            fbq('track', 'AddToCart');
          `,
          }
        : null,
      hasMetaScripts
        ? {
            innerHTML: `
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({ event: "add_to_cart" });
          `,
          }
        : null,
    ].filter(Boolean);

    const noscriptConfigs = [
      {
        innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WT7WBGF"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      },
      hasMetaScripts
        ? {
            innerHTML: `<img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=592232429092515&ev=PageView&noscript=1"/>`,
          }
        : null,
    ].filter(Boolean);

    scriptConfigs.forEach(({ src, async, innerHTML }) => {
      const script = document.createElement("script");
      if (src) {
        script.src = src;
        script.async = async || false;
      }
      if (innerHTML) {
        script.innerHTML = innerHTML;
      }
      document.body.appendChild(script);
      scripts.push(script);
    });

    noscriptConfigs.forEach(({ innerHTML }) => {
      const noscript = document.createElement("noscript");
      noscript.innerHTML = innerHTML;
      document.body.prepend(noscript);
      noscripts.push(noscript);
    });

    return () => {
      scripts.forEach((script) => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      });

      noscripts.forEach((noscript) => {
        if (document.body.contains(noscript)) {
          document.body.removeChild(noscript);
        }
      });
    };
  }, [hasMetaScripts, analyticsEnabled]);
};

export const useTrackingScripts = (selectedPlan) => {
  const analyticsEnabled = window.AppENV.analyticsEnabled;
  useEffect(() => {
    if (!analyticsEnabled || !selectedPlan) {
      return;
    }

    const cleanupScripts = () => {
      document
        .querySelectorAll(".tracking-script")
        .forEach((script) => script.remove());
      document
        .querySelectorAll(".tracking-noscript")
        .forEach((noscript) => noscript.remove());
    };

    cleanupScripts();

    // --- Meta Pixel Script ---
    const fbScript = document.createElement("script");
    fbScript.classList.add("tracking-script");
    const fbPixelScriptContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '592232429092515');
      fbq('track', 'PageView');
      fbq('track', 'AddPaymentInfo', {
        content_category: '${selectedPlan.productType}',
        value: ${selectedPlan.price},
        currency: '${selectedPlan.currency}'
      });
    `;
    fbScript.innerHTML = fbPixelScriptContent;
    document.body.appendChild(fbScript);

    // --- NoScript Image for Meta Pixel ---
    const noScript = document.createElement("noscript");
    noScript.classList.add("tracking-noscript");
    const noScriptContent = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=592232429092515&ev=PageView&noscript=1"/>
    `;
    noScript.innerHTML = noScriptContent;
    document.body.prepend(noScript);

    // --- Google dataLayer ---
    const gtmScript = document.createElement("script");
    gtmScript.classList.add("tracking-script");
    const gtmScriptContent = `
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
          currency: "${selectedPlan.currency}",
          value: ${selectedPlan.price},
          items: [{
            item_category: "${selectedPlan.productType}",
            price: ${selectedPlan.price}
          }]
        }
      });
    `;
    gtmScript.innerHTML = gtmScriptContent;
    document.body.appendChild(gtmScript);

    return cleanupScripts;
  }, [selectedPlan, analyticsEnabled]);
};
